// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Qz7DP","spin":"Spinner_spin__CnP0Z"};